import store from '~/store'
import navigation from '~/navigation'

store.dispatch('navigation/setNavItems', {navItems: navigation.navigation})
store.dispatch('navigation/setSecondaryNavItems', {secondaryNavItems: navigation.secondaryNavigation})
store.dispatch('navigation/setStandaloneNavItems', {standaloneNavItems: navigation.standaloneNavigation})
store.dispatch('navigation/setApoOneNavItems', {apoOneNavItems: navigation.apoOneNavigation})
